import type { Point2d } from "@logic/lib/2d"
import { screenToStudio } from "@logic/lib/design"

import { findScrollPositionState } from "~/containers/LegacyDesigner/state/scroll"
import {
  findMousePositionState,
  translateMousePosition,
} from "~/hooks/useMousePosition"

import type { TransactionOperation } from "."
import { zoomState } from "../../view"

export const getMousePositionOnScreen: TransactionOperation<
  undefined,
  Point2d
> = ({ get }) => {
  const position = get(findMousePositionState(`Studio`))
  const offset = get(findScrollPositionState(`Studio`))
  // transactions can't get selectors,
  // so we just factor out the logic for computedMousePosition and apply it
  const { x, y } = translateMousePosition(position, offset)

  return { x, y }
}

export const getMousePositionInStudio: TransactionOperation<
  undefined,
  Point2d
> = ({ get }) => {
  const position = get(findMousePositionState(`Studio`))
  const offset = get(findScrollPositionState(`Studio`))
  const translatedMousePosition = translateMousePosition(position, offset)
  const zoom = get(zoomState)
  const { x, y } = screenToStudio.point(translatedMousePosition, zoom)

  return { x, y }
}
